import Vue from 'vue'
import Router from 'vue-router'
const Navbar = () =>
  import(/* webpackChunkName: "Tabbar" */ '@/components/Navbar.vue');
const Tabbar = () =>
  import(/* webpackChunkName: "Tabbar" */ '@/components/Tabbar.vue');

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
        navbar: Navbar,
        tabbar: Tabbar
      }
    },
    {
      path: '/trading',
      name: 'trading',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Trading.vue'),
        navbar: Navbar,
        tabbar: Tabbar
      }
    },
    {
      path: '/invest',
      name: 'invest',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Invest.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/share',
      name: 'share',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Share.vue'),
        navbar: Navbar,
        tabbar: Tabbar
      }
    },
    {
      path: '/mine',
      name: 'mine',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Mine.vue'),
        navbar: Navbar,
        tabbar: Tabbar
      }
    },
    {
      path: '/notification',
      name: 'notification',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Notification.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/deposit',
      name: 'deposit',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Deposit.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/recharge',
      name: 'recharge',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Recharge.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Withdrawal.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/team',
      name: 'team',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Team.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/task',
      name: 'task',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/Task.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/profitList',
      name: 'profitList',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/ProfitList.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/dailyRevenueList',
      name: 'dailyRevenueList',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/DailyRevenueList.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/investedList',
      name: 'investedList',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/InvestedList.vue'),
        tabbar: Tabbar
      }
    },
    {
      path: '/productDetails',
      name: 'productDetails',
      components: {
        default: () => import(/* webpackChunkName: "about" */ './views/ProductDetails.vue'),
        tabbar: Tabbar
      }
    }
  ],
  scrollBehavior (to, from ,savedPosition) {
     // 1. 获取当前的屏幕的宽度
     let windowWidth = document.documentElement.offsetWidth;
     if (windowWidth >= 600) {
      windowWidth = 360;
     }
     // 2. 以标准的375屏幕 根元素100px的标准  需要3.75rem占满整屏的值 作为参照点
     const htmlFontSize = windowWidth / 360 * 3.6;
     // 3. 把当前根元素的字体大小设置给当前html的fontSize 注意要带单位
     document.querySelector('html').style.fontSize = htmlFontSize + 'px';
    return {x:0,y:0}
  }
})

// 判断是否需要登录权限 以及是否登录
router.afterEach((to, from) => {
  Vue.prototype.login(to.query.code)
 })

 export default router;
